// Actions
import { SET_NEW_LIST } from "../actionTypes/attributes.actionTypes";

// Classes
import { AttributesReducerState } from "../classes/attributes.classes";

const initialState = new AttributesReducerState();

export const AttributesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_NEW_LIST:
      return { ...state, newList: action.payload };
    default:
      return state;
  }
};
